import React, {PropTypes} from 'react';
import {withGoogleMap, GoogleMap, Marker, InfoWindow} from 'react-google-maps';
import withScriptjs from 'react-google-maps/lib/async/withScriptjs';
import _ from 'lodash';
import Spinner from "../../Spinner";
import {getCenter} from "../../Map/getCenterLatLng";
import Form, {SelectInput, TextInput} from '../../Form';
import {observer, inject} from 'mobx-react';
import {observable, toJS} from 'mobx';
import DataTable from "../../DataTable";
/*global google*/

const googleMapURL = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDT97SQ4uDqmLieE9aCioJXuK6n17jHZMI';
const AsyncGoogleMap = withScriptjs(withGoogleMap(props => (<GoogleMap
    ref={props.onMapLoad}
    defaultZoom={7}
    defaultCenter={getCenter(props.markers)}
    onClick={props.onMapClick}
  >
    {props.markers && props.markers.map(marker => (
      <Marker
        position={{lat: marker.latitude, lng: marker.longitude}}
        key={`ticket-map-marker-${marker.station_id}`}
        icon={{
          // path: `M125 410 c-56 -72 -111 -176 -120 -224 -7 -36 11 -83 49 -124 76 -85 223 -67 270 31 28 60 29 88 6 150 -19 51 -122 205 -148 221 -6 3 -32 -21 -57 -54z m110 -175 c35 -34 33 -78 -4 -116 -35 -35 -71 -37 -105 -7 -40 35 -43 78 -11 116 34 41 84 44 120 7z`,
          path: google.maps.SymbolPath.CIRCLE,
          fillColor: marker.color,
          strokeColor: 'white',
          fillOpacity: 1,
          scale: 8,
          strokeWeight: 1
        }}
        onClick={() => props.onClickMarker(marker)}
        onMouseOver={() => props.onMouseOverMarker(marker)}
      >
        {(+props.visibleMarkerId === +marker.station_id) && (
          <InfoWindow>
            <div>
              <strong style={{fontSize:'15px', fontWeight: '500'}}>{marker.station_name}</strong><br/>
              <small>{marker.duration}</small><br/><br/>
              <table style={{padding: '10px'}}>
                <tbody>
                <tr><th>Summary</th><td>{marker.ticket.summary}</td></tr>
                <tr><th>Description</th><td>{marker.ticket.description}</td></tr>
                <tr><th>Status</th><td>{marker.ticket.status && marker.ticket.status.caption}</td></tr>
                <tr><th>Reason</th><td>{marker.ticket.reason && marker.ticket.reason.caption}</td></tr>
                <tr><th>Action</th><td>{marker.ticket.action && marker.ticket.action.caption}</td></tr>
                </tbody>
              </table>
            </div>
          </InfoWindow>
        )}
      </Marker>
    ))}
  </GoogleMap>
)));

@inject('ticketStatusStore', 'ticketActionStore', 'ticketReasonStore', 'ticketStore')
@observer
export default class TicketMap extends React.Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  @observable visibleMarkerId = null;

  onMouseOverMarker = marker => this.visibleMarkerId = marker.station_id;

  onClickMarker = (marker) => {
    this.context.router.push(`/monitoring/ticket/tabular/${marker.ticket.id}/view`);
  };

  getInfoTableData = (markers) => {
    const {ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore} = this.props;
    if(+ticketStore.viewBy === 1){
      return ticketStatusStore.items.map(item => {
        return {
          id: item.id,
          caption: item.caption,
          color: <i className='fa fa-circle' style={{color: item.color}}/>,
          number: markers ? markers.filter(marker => marker.ticket && +marker.ticket.status_id === +item.id).length : '-'
        }
      });
    } else if (+ticketStore.viewBy === 2) {
      return ticketReasonStore.items.map(item => {
        return {
          id: item.id,
          caption: item.caption,
          color: <i className='fa fa-circle' style={{color: item.color}}/>,
          number: markers ? markers.filter(marker => marker.ticket && +marker.ticket.reason_id === +item.id).length : '-'
        }
      });
    } else if (+ticketStore.viewBy === 3) {
      return ticketActionStore.items.map(item => {
        return {
          id: item.id,
          caption: item.caption,
          color: <i className='fa fa-circle' style={{color: item.color}}/>,
          number: markers ? markers.filter(marker => marker.ticket && +marker.ticket.action_id === +item.id).length : '-'
        }
      });
    }
  };

  filterMarkerByShow = (markers) => {
    const {ticketStore} = this.props;
    if(!!ticketStore.viewBy && !!ticketStore.show){
      return markers.filter(marker => {
        switch(+ticketStore.viewBy){
          case 1: return +marker.ticket.status_id === +ticketStore.show;
          case 2: return +marker.ticket.reason_id === +ticketStore.show;
          case 3: return +marker.ticket.action_id === +ticketStore.show;
          default: return false;
        }
      });
    } else {
      return markers
    }
  };

  renderSelectInputs = () => {
    const {ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore} = this.props;
    let showOptions = null;
    switch (+ticketStore.viewBy){
      case 1: showOptions = ticketStatusStore.items; break;
      case 2: showOptions = ticketReasonStore.items; break;
      case 3: showOptions = ticketActionStore.items; break;
      default: showOptions = null; break;
    }
    return (
      <div>
        <div className="formInput">
          <label>View By</label>
          <select value={ticketStore.viewBy || ''} onChange={ticketStore.onChangeViewBy}>
            {ticketStore.viewByOptions.map(option => (
              <option
                key={option.id}
                value={option.id}
              >
                {option.name}
              </option>
            ))}
          </select>
        </div>
        <div className="formInput">
          <label>Show</label>
          <select value={ticketStore.show || ''} onChange={ticketStore.onChangeShow}>
            <option value={''}>All</option>
            {showOptions && showOptions.map(option => (
              <option
                key={option.id}
                value={option.id}
              >
                {option.caption}
              </option>
            ))}
          </select>
        </div>
      </div>
    )
  };

  render() {
    const {ticketStatusStore, ticketActionStore, ticketReasonStore, ticketStore, userStore} = this.props;

    let markers = ticketStatusStore.items.length > 0 && ticketReasonStore.items.length > 0 && ticketActionStore.items.length > 0
      ? ticketStore.getMarkers({
          statusItems: ticketStatusStore.items,
          reasonItems: ticketReasonStore.items,
          actionItems: ticketActionStore.items,
          ticketItems: ticketStore.filteredTickets,
          users: userStore.items
        })
      : [];


    return(
      <div className='flex flex-row space-between full-width'>
        <div className='three-fourth'>
          {markers.length > 0 && <AsyncGoogleMap
            googleMapURL={googleMapURL}
            loadingElement={
              <Spinner />
            }
            containerElement={
              <div style={{height: '60vh'}}/>
            }
            mapElement={
              <div style={{height: '100%'}}/>
            }
            onMapLoad={_.noop}
            onMapClick={_.noop}
            markers={this.filterMarkerByShow(markers)}
            onMarkerRightClick={_.noop}
            onClickMarker={this.onClickMarker}
            onMouseOverMarker={this.onMouseOverMarker}
            visibleMarkerId={this.visibleMarkerId}
          />}
        </div>
        <div className='flex flex-column one-fourth'>
          <div>
            <Form>
              {this.renderSelectInputs()}
            </Form>
          </div>
          <br/><br/>
          <div>
            <DataTable data={this.getInfoTableData(markers)} columns={ticketStore.infoTableColumn} slug={''}/>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/Ticket/TicketMap.js